import { isAuthenticated } from '@/common/utils/routerMixins';

import Dashboard from './views/Dashboard.vue';
import ExternalDashboard from './views/ExternalDashboard.vue';
import ItemDetailView from './views/ItemDetailView.vue';
import ItemList from './views/ItemList.vue';
import LogList from './views/LogList.vue';
import NewsletterRegistrationList from './views/NewsletterRegistrationList.vue';
import ResearchCreate from './views/ResearchCreate.vue';
import ResearchDetail from './views/ResearchDetail.vue';
import ResearchList from './views/ResearchList.vue';
import UserList from './views/UserList.vue';
import UserDetail from './views/UserDetail.vue';


const PREFIX = '/adminx';


export default [
  {
    path: `${PREFIX}/`,
    name: 'admin-dashboard',
    component: Dashboard,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/users/:id/`,
    name: 'admin-user-detail',
    component: UserDetail,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/users/`,
    name: 'admin-user-list',
    component: UserList,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/external/`,
    name: 'admin-external',
    component: ExternalDashboard,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/researches/`,
    name: 'admin-research-list',
    component: ResearchList,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/researches/:uuid/`,
    name: 'admin-research-detail',
    component: ResearchDetail,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/items/`,
    name: 'admin-items',
    component: ItemList,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/items/:id`,
    name: 'admin-item-detail',
    component: ItemDetailView,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/create-research/`,
    name: 'admin-research-create',
    component: ResearchCreate,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/newsletter-registration/`,
    name: 'admin-newsletter-registration-list',
    component: NewsletterRegistrationList,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
  {
    path: `${PREFIX}/logs/`,
    name: 'log-list',
    component: LogList,
    beforeEnter: isAuthenticated,
    meta: {
      app: 'admin',
    },
  },
];
